import gql from 'graphql-tag';

export const GET_USER_QUERY = gql`
  query getUserInfo {
    viewer {
      id
      emailAddress
      emailCorrelationId
      personalDetails {
        firstName
        lastName
      }
    }
  }
`;
